"use client";
import { createTheme } from "@mui/material/styles";
import "@fontsource/poppins";
import colors from "@/util/colors";

export const theme = createTheme({
  typography: {
    fontFamily: "'Poppins', sans-serif",
  },
  //Marbury Theme
  palette: {
    // Marbury light orange = #EEC783
    primary: {
      main: colors.primary.main,
      dark: colors.primary.dark,
      accent: colors.primary.accent,
      error: colors.primary.error,
      contrastText: "#ffffff",
    },
    iconGrey: {
      main: "#0000008a",
    },
  },
  components: {
    MuiDivider: {
      styleOverrides: {
        root: {
          borderBottomWidth: "1px !important",
          borderColor: "#dc9b28 !important",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          paddingTop: "2px",
          paddingBottom: "2px",
          height: "fit-content !important",
        },
      },
    },
    MuiPopper: {
      styleOverrides: {
        root: {
          zIndex: "20000 !important",
        },
      },
    },
    MuiGridToolbarQuickFilter: {
      defaultProps: {},
    },
    MuiTextField: {
      defaultProps: {
        size: "small",
        inputProps: {
          autoComplete: "new-password",
        },
      },
    },
    MuiInput: {
      defaultProps: {
        autoComplete: "new-password",
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
        disableRipple: true,
        size: "small",
      },
      styleOverrides: {
        root: {
          lineHeight: "1 !important",
          padding: "0.5rem 1rem !important",
          textTransform: "none",
          fontSize: "0.875  rem",
          fontWeight: "normal",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          // Default hover background for all IconButtons
          "&:hover": {
            backgroundColor: "#fcf7ee",
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: "0.875rem",
        },
      },
    },
    MuiSkeleton: {
      styleOverrides: {
        root: {
          backgroundColor: "#dc9b2820",
        },
      },
    },
    MuiTab: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          minWidth: "0",
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          border: "none !important",
          boxShadow: "none !important",
          borderRadius: "1rem !important",
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          borderRadius: "0.5rem",
        },
      },
    },
    MuiExpanded: {
      styleOverrides: {
        root: {
          margin: "12px !important  ",
          minHeight: "32px",
        },
      },
    },
    MuiAutocomplete: {
      defaultProps: {
        slotProps: {
          textField: {
            inputProps: {
              autoComplete: "new-password",
            },
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          padding: "1rem 0 1rem 0",
          marginRight: "2rem",
        },
      },
    },
  },
});
